import React, { useState } from "react";
import Layout, { Main } from "../Layout";
import { addDuration, dateDifference, formatDate } from "../utils/DateFormater";
import { useNavigate, useLocation } from "react-router-dom";
import { useApi } from "../Api/ApiContext";
import { useAsync, useAsyncFn } from "react-use";
import useMeStore from "../store/MeStore";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Row,
  Alert,
  Button,
  FormFeedback,
  Spinner,
} from "reactstrap";
import Input from "../component/Input";
import Select from "../component/Select";
import Textarea from "../component/Textarea";
import useCelebritiesStore from "../store/CelebritiesStore";

const ProductForm = () => {
  const location = useLocation();
  const { getMe } = useApi();

  const navigate = useNavigate();
  const { createProduct, updateProduct, getProductCategories } = useApi();
  const product = location.state ? location.state.product : null;
  const { me, storeMe } = useMeStore();
  const [{ loading: meLoader, error: meError }, loadMe] = useAsyncFn(
    () => getMe(),
    []
  );
  const {
    loading: categoriesLoading,
    error: categoriesError,
    value: categories,
  } = useAsync(getProductCategories, []);
  const [{ loading, error, value: response }, saveProduct] = useAsyncFn(
    (product) => createProduct(product),
    []
  );
  const [
    { loading: updateLoading, error: updateError, value: updateResponse },
    update,
  ] = useAsyncFn((product) => updateProduct(product), []);

  const [id, setId] = useState(product ? product.id : null);
  const [category, setCategory] = useState(product ? product.category : "");
  const [quantity, setQuantity] = useState(
    product && product.quantity ? product.quantity : ""
  );
  const [price, setPrice] = useState(product ? product.price : "");
  const [currency, setCurrency] = useState(product ? product.currency : "");
  const [launchDate, setLaunchDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [description, setDescription] = useState(
    product ? product.description : ""
  );

  const [categoryError, setCategoryError] = useState(null);
  const [quantityError, setQuantityError] = useState(null);
  const [priceError, setPriceError] = useState(null);
  const [currencyError, setCurrencyError] = useState(null);
  const [launchDateError, setLaunchDateError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const { celebrities } = useCelebritiesStore();

  const handleCategoryChange = (e) => {
    setCategory(
      categories.find((c) => parseInt(c.id) === parseInt(e.target.value))
    );
    setCategoryError(null);
  };
  const handleQuantityChange = (e) => {
    setQuantity(
      e.target.value === "" || e.target.value === "0" ? "" : e.target.value
    );
    setQuantityError(null);
  };

  const handlePriceChange = (e) => {
    setPrice(
      e.target.value === "" || e.target.value === "0" ? "" : e.target.value
    );
    setPriceError(null);
  };

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value === "" ? "" : e.target.value);
    setCurrencyError(null);
  };

  const handleLaunchDateChange = (e) => {
    setLaunchDate(e.target.value);
    setLaunchDateError(null);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setEndDateError(null);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
    setDescriptionError(null);
  };

  const isValidForm = () => {
    let errorCount = 0;
    if (!category) {
      errorCount++;
      setCategoryError("Cet champ est obligatoire");
    }
    if (category?.slug === "dedicace-musicale" && !quantity) {
      errorCount++;
      setQuantityError("Ce champ est obligatoire et doit être différent de 0.");
    }
    if (!price) {
      errorCount++;
      setPriceError("Ce champ est obligatoire et doit être différent de 0.");
    }
    if (!currency) {
      errorCount++;
      setCurrencyError("Ce champ est obligatoire.");
    }
    if (category?.slug === "dedicace-musicale" && !launchDate) {
      errorCount++;
      setLaunchDateError("Ce champ est obligatoire.");
    }
    if (category?.slug === "dedicace-musicale" && !endDate) {
      errorCount++;
      setEndDateError("Ce champ est obligatoire.");
    }
    if (
      launchDate &&
      endDate &&
      dateDifference(new Date(launchDate), new Date(endDate)) < 7
    ) {
      errorCount++;
      setEndDateError(
        "Les commandes doivent être clôturées au plus tard 7 jours avant la date de sortie."
      );
    }
    if (!description.trim()) {
      errorCount++;
      setDescriptionError("Ce champ est obligatoire.");
    }

    return errorCount === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValidForm()) {
      const product = {
        id: id ? id : null,
        categoryId: parseInt(category.id),
        quantity: !quantity ? null : parseInt(quantity),
        price: parseFloat(price),
        currency: currency,
        launchDate: !launchDate ? null : launchDate,
        endDate: !endDate ? null : endDate,
        description: description,
      };
      if (product.id) {
        update(product).then((res) => {
          loadMe().then((res) => storeMe(res));
          navigate("/admin/products");
        });
        return;
      }
      saveProduct(product).then((res) => {
        loadMe().then((res) => storeMe(res));
        navigate("/admin/products");
      });
    }
  };
  if (!product && me.products.length >= 3) {
    return (
      <Layout
        backPath={{ pathname: "/admin/products" }}
        celebrities={celebrities.items}
      >
        <Main>
          <Row className={"my-3"}>
            <Col sm={8} lg={6} className="mx-auto">
              <Alert color={"danger"}>
                <div className={"fw-bold fs-6 mb-3"}>
                  Vous ne pouvez pas ajouter plus de trois produits.
                </div>
                <div>
                  Veuillez supprimer un produit pour en ajouter un autre.
                </div>
              </Alert>
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }
  if (loading || updateLoading) {
    return (
      <Layout celebrities={celebrities.items}>
        <Main>
          <Row>
            <Col lg={2} className="mx-auto">
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }

  return (
    <Layout
      backPath={{ pathname: "/admin/products" }}
      celebrities={celebrities.items}
    >
      <Main className="my-3">
        <Row>
          <Col sm={8} lg={6} className="mx-auto">
            <h1 className="fs-4">
              {product ? "Modifier un produit" : "Ajouter un produit"}
            </h1>
          </Col>
        </Row>
        {(error || updateError) && (
          <Row>
            <Col sm={8} lg={6} className={"mx-auto"}>
              <Alert color={"danger"}>
                Une erreur est survenue. Merci de réessayer plus tard.
              </Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col sm={8} lg={6} className="mx-auto">
            <Form>
              <FormGroup>
                <Label htmlFor={"type"}>Type de produit</Label>
                <Select
                  className={
                    categoryError ? "is-invalid form-control" : "form-control"
                  }
                  id={"type"}
                  type="select"
                  onChange={handleCategoryChange}
                >
                  <option value="" selected>
                    Sélection
                  </option>
                  {categories &&
                    categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                </Select>
                <FormFeedback>{categoryError}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label htmlFor={"quantity"}>Quantité</Label>
                <Input
                  className={
                    quantityError ? "is-invalid form-control" : "form-control"
                  }
                  id="quantity"
                  type="number"
                  min={0}
                  value={quantity}
                  onChange={handleQuantityChange}
                  disabled={category?.slug !== "dedicace-musicale"}
                />
                <FormFeedback>{quantityError}</FormFeedback>
              </FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor={"price"}>Prix</Label>
                    <Input
                      className={
                        priceError ? "is-invalid form-control" : "form-control"
                      }
                      id="price"
                      type="number"
                      value={price}
                      min={me.currency === "euro" ? 1 : 1000}
                      step={me.currency === "euro" ? 1 : 5}
                      onChange={handlePriceChange}
                      invalid={priceError}
                    />
                    <FormFeedback>{priceError}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor={"devise"}>Devise</Label>
                    <Select
                      className={
                        currencyError
                          ? "is-invalid form-control"
                          : "form-control"
                      }
                      id={"currency"}
                      type="select"
                      onChange={handleCurrencyChange}
                    >
                      <option value="" selected>
                        Sélection
                      </option>
                      <option value={"euro"} selected={currency === "euro"}>
                        EURO
                      </option>
                      <option value={"cfa"} selected={currency === "cfa"}>
                        CFA
                      </option>
                    </Select>
                    <FormFeedback>{currencyError}</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Label htmlFor={"launch-date"}>
                  Date de sortie de la chanson
                </Label>
                <Input
                  className={
                    launchDateError ? "is-invalid form-control" : "form-control"
                  }
                  id="launch-date"
                  type="date"
                  min={formatDate(
                    addDuration(new Date(), { days: 1 }),
                    "Y-MM-dd"
                  )}
                  value={
                    product &&
                    category?.slug === "dedicace-musicale" &&
                    product.launchDate
                      ? formatDate(new Date(product.launchDate), "Y-MM-dd")
                      : launchDate
                  }
                  onChange={handleLaunchDateChange}
                  disabled={category?.slug !== "dedicace-musicale"}
                />
                <FormFeedback>{launchDateError}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="end-date">Date de limite de commande</Label>
                <Input
                  className={
                    endDateError ? "is-invalid form-control" : "form-control"
                  }
                  id="end-date"
                  type="date"
                  value={
                    product &&
                    category?.slug === "dedicace-musicale" &&
                    product.endDate
                      ? formatDate(new Date(product.endDate), "Y-MM-dd")
                      : endDate
                  }
                  onChange={handleEndDateChange}
                  min={formatDate(
                    addDuration(new Date(), { days: 1 }),
                    "Y-MM-dd"
                  )}
                  max={formatDate(
                    addDuration(
                      new Date(launchDate !== "" && launchDate.toString()),
                      {
                        days: -7,
                      }
                    ),
                    "Y-MM-dd"
                  )}
                  disabled={category?.slug !== "dedicace-musicale"}
                />
                <FormFeedback>{endDateError}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label htmlFor={"description"}>Description</Label>
                <Textarea
                  className={
                    descriptionError
                      ? "is-invalid form-control"
                      : "form-control"
                  }
                  id="description"
                  placeholder="200 caractères maximum"
                  type="textarea"
                  value={description}
                  rows={5}
                  maxLength={500}
                  onChange={handleDescriptionChange}
                />
                <FormFeedback>{descriptionError}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col>
                    <Button
                      className={"offset-0 offset-lg-10 col-12 col-lg-2"}
                      color="primary"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Valider
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </Main>
    </Layout>
  );
};

export default ProductForm;
